define(function (require) {
    "use strict";

    var LE = require("app");
    var LEConfig = require("assets/config/le-env-conf");
    var UserManagementLayout = require("user-management-views/UserManagementLayout");
    var UserManagementRouteController = require("user-management-controllers/UserManagementRouteController");
    var UsersDataManager = require("user-management-controllers/data/UsersDataManager");
    var HeaderTabsController = require("user-management-controllers/HeaderTabsController");
    var channels = require("user-management-assets/data/channels.json");
    var StringFormats = require("utils/StringFormats");

    return LE.module("LEUserManagement", function (LEUserManagement, LE, Backbone, Marionette, $, _) {

        var moduleLayout;
        var moduleRouteController;
        var dataManager;
        var headerTabsController;

        // Expose the public (cross modules) handlers on the module channel
        (function() {
            LEUserManagement.channel.reply(LE.mediaCodes.userManagement.reqres.profilesCollection, function() {
                return dataManager.getData(dataManager.getEntities().PROFILES);
            });

            LEUserManagement.channel.reply(LE.mediaCodes.userManagement.reqres.profilesRolesGroup, function() {
                return dataManager.getProfilesRolesGroupOrder();
            });
        })();

        LEUserManagement.addInitializer(function() {
            LEUserManagement.logger.debug("initializing start", "userManagement:addInitializer");
            LEUserManagement.channels = channels;

            moduleLayout = new UserManagementLayout();
            dataManager = new UsersDataManager({
                module:{
                    name: LEUserManagement.moduleName,
                    mainRegion: LEUserManagement.getMainRegion(),
                    showLoader: LEUserManagement.showLoader,
                    closeLoader: LEUserManagement.closeLoader,
                    notifier: LEUserManagement.notifier
                }
            });
            headerTabsController = HeaderTabsController.initialize();
            moduleRouteController = new UserManagementRouteController();


            // lock slide down handle
            LEUserManagement.lockReporting = true;
        });

        LEUserManagement.getMainView = function() {
            //return moduleRouteController.userManagementController.getMainView();
            return moduleLayout;
        };

        LEUserManagement.getMainRegion = function() {
            return LEUserManagement.getMainView().mainRegion;
        };

        LEUserManagement.getDataManager = function() {
            return dataManager;
        };

        LEUserManagement.getRouteController = function() {
            return moduleRouteController;
        };

        LEUserManagement.getHeaderTabsController = function() {
            return headerTabsController;
        };

        LEUserManagement.showLoader = function(options) {
            moduleLayout.showLoader(options);
        };

        LEUserManagement.closeLoader = function() {
            moduleLayout.closeLoader();
        };

        LEUserManagement.getGeneralErrorMsg = function(errorObject) {
            return  StringFormats.getGeneralErrorMsg(errorObject);
        };

        LEUserManagement.hasAllUsersEditPrivilege = function() {
            return LE.sessionManager.hasPrivilege(LE.sessionManager.PRIVILEGES.EDIT_AC_USERS_USERS);
        };

        LEUserManagement.hasAgentUserEditPrivilege = function() {
            return LE.sessionManager.hasPrivilege(LE.sessionManager.PRIVILEGES.EDIT_AC_USERS_AGENT);
        };

        LEUserManagement.hasAgentManagerUserEditPrivilege = function() {
            return LE.sessionManager.hasPrivilege(LE.sessionManager.PRIVILEGES.EDIT_AC_USERS_AGENT_MANAGER);
        };

        LEUserManagement.hasAllUsersViewPrivilege = function() {
            return (!LEUserManagement.hasAgentUserEditPrivilege() && !LEUserManagement.hasAgentManagerUserEditPrivilege()) || LEUserManagement.hasAllUsersEditPrivilege() || LE.sessionManager.getConfig().isLPA;
        };

        LEUserManagement.hasAllProfilesEditPrivilege = function() {
            return LE.sessionManager.hasPrivilege(LE.sessionManager.PRIVILEGES.EDIT_AC_USERS_PROFILES);
        };

        LEUserManagement.hasAgentProfileEditPrivilege = function() {
            return LE.sessionManager.hasPrivilege(LE.sessionManager.PRIVILEGES.EDIT_AC_USERS_AGENT_PROFILES);
        };

        LEUserManagement.hasAgentManagerProfileEditPrivilege = function() {
            return LE.sessionManager.hasPrivilege(LE.sessionManager.PRIVILEGES.EDIT_AC_USERS_AGENT_MANAGER_PROFILES);
        };

        LEUserManagement.hasAllProfilesViewPrivilege = function() {
            return (!LEUserManagement.hasAgentProfileEditPrivilege() && !LEUserManagement.hasAgentManagerProfileEditPrivilege()) || LEUserManagement.hasAllProfilesEditPrivilege() || LE.sessionManager.getConfig().isLPA;
        };

        // in order to check if the user has privilege to view the entire agent group tree we check for agent group privilege that can be given only to agents
        LEUserManagement.hasEntireAgentGroupTreePrivilege = function() {
            return LE.sessionManager.hasPrivilege(LE.sessionManager.PRIVILEGES.EDIT_AC_USERS_AGENT_GROUPS) || LE.sessionManager.getConfig().isLPA;
        };

        LEUserManagement.hasBatchUpdatePrivileges = function() {
            return LE.siteSettings.accountSettings.isAcUser() && (LEUserManagement.hasAllUsersEditPrivilege() || LEUserManagement.hasAgentUserEditPrivilege());
        };

        LEUserManagement.hasBatchUpdates = function() {
            return LE.sessionManager.hasProfilesFeature() && LEUserManagement.hasBatchUpdatePrivileges() && LEConfig.usersBatchUpdates.enabled;
        };

    });

});

